<div
  class="block w-full cursor-custom group transition-all duration-300"
  (click)="onClick()">
  <div class="relative w-full overflow-hidden aspect-square bg-[#1a1a1a]">
    <div
      [lazyBgLoader]="titlePhotoUrl()"
      class="w-full h-full transition-transform duration-300 group-hover:scale-105"></div>
  </div>

  <div class="mt-3">
    <p class="text-xs leading-4 text-neon uppercase mb-1"> {{ photoCount() }} {{ 'gallery.photos' | translate }} </p>
    <h3 class="text-white uppercase text-base mb-1 transition-colors duration-300 group-hover:text-neon">
      {{ albumName() }}
    </h3>
    <p class="text-white/70 text-sm leading-relaxed line-clamp-2">
      {{ albumDescription() }}
    </p>
  </div>
</div>
